import React from "react";
import AdminHeader from "../../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../../components/admin/AdminFooter";
import AdminSocialMediaAdd from "../../../../views/admin/cms/socialMedia/AdminSocialMediaAdd";

const AdminSocialMediaAddPage = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
        <AdminSocialMediaAdd />
      <AdminFooter />
    </div>
  );
};

export default AdminSocialMediaAddPage;